import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Menu, Header, Button } from "semantic-ui-react";
import logo from "../../logo.png";
import userAvatar from "../../userAvatar.png";
import { Logout } from "../../actions/authActions";

const MenuBar = () => {
  const dispatch = useDispatch();
  const reviewer = useSelector((state) => state.mode.reviewer);
  const user = useSelector((state) => state.auth.user);
  const color = reviewer ? "grey" : "black";
  return (
    <Menu color={color} inverted style={{ height: "4rem", borderRadius: 0 }}>
      <Menu.Item name="home" as={Link} to="/">
        <img src={logo} alt="logo" />
      </Menu.Item>
      {user.id && (
        <Menu.Menu position="right">
          <Menu.Item>
            <Header
              as="h5"
              sub
              content={`${user.firstName} ${user.lastName}`}
              style={{ color: "#FFF" }}
            />
          </Menu.Item>
          <Menu.Item content={<img src={userAvatar} alt="user avatar" />} />
          <Menu.Item>
            <Button
              color="teal"
              basic
              content="Log Out"
              onClick={() => dispatch(Logout())}
            />
          </Menu.Item>
        </Menu.Menu>
      )}
    </Menu>
  );
};

export default MenuBar;
